import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faRightFromBracket, faUser } from "@fortawesome/free-solid-svg-icons";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";
import { deleteCookie, getCookie } from "cookies-next";
import Swal from "sweetalert2";
// import ProfileImg from "../assets/images/logo/images.jpg";  // Adjust the path as needed
import { getUserDetails } from "../utilities/get-user-details-from-cokies"; // Adjust the path as needed
import { communication, getServerUrl } from "../services/communication"; // Adjust the path as needed

const TopHeader = () => {
  const [dropdown, setDropdown] = useState(false);
  const [userData, setUserData] = useState({ userName: "", userType: "", profile: "", _id: "" });
  const navigate = useNavigate(); // Use `useNavigate` hook for navigation
  const [loader, setLoader] = useState(false);
  const [socket, setSocket] = useState();
  const [notificationCount, setNotificationCount] = useState(0);
  const dropdownRef = useRef(null);

  // Remove cookies & logout
  const logout = () => {
    Swal.fire({
      text: `Do you want to log out?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5149E4",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        deleteCookie("userDetails");
        deleteCookie("userToken");
        navigate("/"); // Use `navigate` instead of `history.push()`
      }
    });
  };

  async function getUserById() {
    try {
      setLoader(true);
      const userDetails = getUserDetails();
      const responseFromServer = await communication.getuserById(userDetails._id);
      if (responseFromServer?.data?.status === "SUCCESS") {
        setUserData(responseFromServer?.data?.user);
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        navigate("/login"); // Use `navigate` instead of `history.push()`
      } else {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
      setLoader(false);
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
      setLoader(false);
    }
  }

  async function getNotificationCount() {
    try {
      const serverResponse = await communication.getNotificationCount();
      if (serverResponse?.data?.status === "SUCCESS") {
        setNotificationCount(serverResponse?.data?.notification);
      } else if (serverResponse?.data?.status === "JWT_INVALID") {
        setLoader(false);
        Swal.fire(serverResponse?.data?.message);
      } else {
        setNotificationCount(0);
      }
    } catch (error) {
      setLoader(false);
      Swal.fire(error?.response?.data?.message || error?.message);
    }
  }

  useEffect(() => {
    const userDetails = getUserDetails();
    setUserData((prev) => ({ ...prev, ...userDetails }));
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <>
      <div className="header_wrraper">
        <div className="header_col position-relative">
          <div
            className="notification_icon"
            // onClick={() => navigate("/main-panel/notification-view")}
          >
            {/* <FontAwesomeIcon title="View Notification" icon={faBell} className="icon" />
            {!["0", null, undefined, 0].includes(notificationCount) && <p>{notificationCount}</p>} */}
          </div>

          <div className="user_details me-4">
            <h4>{userData?.userName}</h4>
            <p className="m-0 py-0">{userData?.userType}</p>
          </div>

          <div ref={dropdownRef} className="mx-2">
            <button
              className="profile_btn"
              onClick={() => {
                setDropdown(!dropdown);
              }}
            >
              <FontAwesomeIcon icon={dropdown ? faAngleUp : faAngleDown} className="icon" />
            </button>
            {dropdown && (
              <div className="account_dropdown">
                <ul className="m-0 p-0">
                  {/* <li
                    onClick={() => {
                      navigate("/main-panel/profile");
                      setDropdown(!dropdown);
                    }}
                  >
                    <FontAwesomeIcon icon={faUser} className="icon" /> My Profile
                  </li> */}
                  <li
                    onClick={() => {
                      logout();
                    }}
                  >
                    <FontAwesomeIcon icon={faRightFromBracket} className="icon" /> Log Out
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TopHeader;
